import * as Api from './api/apies6.js'
window.axios = require('axios');

export default {
    data() {
        return {
            linkAppStore: "https://itunes.apple.com/jp/app/id1201123859?mt=8",
            linkGooglePlay: "https://play.google.com/store/apps/details?id=jp.co.nspictures.mangahot",
            others: "http://mangahot.jp/",
            recommendWorksFromWorksData:[],
            shareTextViewer : '[Trend analysis catch] Manga'
        }
    },

    computed: {
        mangahotDetailUrl: function() {
          return process.env.DETAIL_URL
        }
    },
    methods: {
      getApiConfig () {
        const basePath = process.env.API_ENDPOINT
        return new Api.ApiConfig(basePath, {})
      },

      getMangahotDetailUrl(workCode, restoreToken = null, personaId = null, timeRes = null) {
        let query = ""
        if (restoreToken !== null) {
          query += "&rt=" + restoreToken
        }
        if (timeRes !== null) {
          query += "&timeres=" + timeRes
        }
        if (personaId !== null) {
          query += "&pid=" + personaId
        }
        if (query.length > 0) {
          query = "?" + query.slice(1);
        }

        let url = this.mangahotDetailUrl
        if (url.charAt(0) === "/") {
          // development server(test server)
          // Due to limitation of dummy page, workcode has a parameter.
          query += query.length > 0 ? "&" : "?"
          query += "workcode=" + workCode
          return this.mangahotDetailUrl + "/" + query
        } else {
          // Staging or Production server.
          return this.mangahotDetailUrl + "/" + workCode + query
        }
      },
      isMobile(){
          return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      },

      isOnlyMobile(){
        return /iPhone|blackberry|webos|Windows Phone|iemobile|Android/i.test(navigator.userAgent);
      },
      
      isIpad(){
          return /iPad/i.test(navigator.userAgent);
      },
      isIpod(){
        return /iPod/i.test(navigator.userAgent);
      },

      feedBackReadProgress(){
        let feedbackworkCode = this.$cookies.get('feedbackworkCode')
        let feedbackstoryId = this.$cookies.get('feedbackstoryId')
        let feedbackcurrentPageIndex = this.$cookies.get('feedbackcurrentPageIndex')
        let feedbacktotalPages = this.$cookies.get('feedbacktotalPages')
        let feedbacktimeRes = this.$cookies.get('feedbacktimeRes')
        let feedbackpid = this.$cookies.get('feedbackpid')
        let userId = this.$cookies.get('userId');

        if(feedbackcurrentPageIndex>feedbacktotalPages){
          feedbackcurrentPageIndex = feedbacktotalPages;
        }
        if(feedbackworkCode!=null && feedbackstoryId!=null && feedbackcurrentPageIndex!=null 
        &&feedbacktotalPages!=null && feedbacktimeRes!=null && feedbackpid!=null
        && feedbackcurrentPageIndex>0){
          let api = new Api.KoreyomoApi(this.getApiConfig())
          let readProgress = api.feedbacksReadProgressPostAsync(feedbackworkCode, feedbackstoryId,
          feedbackcurrentPageIndex, feedbacktotalPages, feedbacktimeRes, feedbackpid, userId);
          
          this.$cookies.remove('feedbackworkCode')
          this.$cookies.remove('feedbackstoryId')
          this.$cookies.remove('feedbackcurrentPageIndex')
          this.$cookies.remove('feedbacktotalPages')
          this.$cookies.remove('feedbacktimeRes')
          this.$cookies.remove('feedbackpid')
        }
      },
      
    /**
     * twitter share
     * @param {type} mangaText
     * @returns {String}
     */
      snsURL:function(mangaText,hashTag){
        let rt = this.recommendWorksFromWorksData.restoreToken
        let hTag = (typeof hashTag == 'undefined' ) ? 'コレヨモ':'マンガほっと'
        let site_url = window.location.host+this.$router.options.base
        
        let url = this.$route.name == 'ResultOfRecommendation' ? 'https://'+site_url+'/recommend?m=3&rt='+rt : window.location.href
        let sns = 'https://twitter.com/intent/tweet?text='+encodeURIComponent(mangaText)+'&hashtags='+encodeURIComponent(hTag)+'&url='
        let href = sns+encodeURIComponent(url)
        return href
      },
      
      /**
       * facebook share
       * @param {type} mangaText
       * @returns {Boolean}
       */
      snsFBURL:function(mangaText){
          let rt = this.recommendWorksFromWorksData.restoreToken
          let site_url = window.location.host+this.$router.options.base
          let url = this.$route.name == 'ResultOfRecommendation' ? 'https://'+site_url+'/recommend?m=3&rt='+rt : window.location.href
          let snsFB = 'https://www.facebook.com/sharer/sharer.php?quote='+encodeURIComponent(mangaText)+'&u='
          let hrefFB = snsFB+encodeURIComponent(url)
          window.open(hrefFB, 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
          return false;
          
      },
      /**
       * google analytics
       * @param {type} hit_type
       * @param {type} event_category
       * @param {type} event_label
       * @param {type} href
       * @returns {undefined}
       */
      gtagFunction: function(hitType, eventCategory,eventLabel,href) {
          let gaOptions = {
            'event_category': eventCategory,
            'event_label': eventLabel
          }
          if(href != 'no'){
            Object.assign(gaOptions,{'transport_type': 'beacon','event_callback': function() {document.location = href;}});
          }
          gtag('event', hitType, gaOptions);
        }
    },
}


// WEBPACK FOOTER //
// ./src/mixin.js